import { Navigate, useRoutes } from 'react-router-dom';
import DashboardLayout from './layouts/dashboard';
import SimpleLayout from './layouts/simple';
import UsersPage from './pages/usersPages';
import BookingPage from './pages/bookingPage';
import StudioPage from './pages/studioPage';
import Login from './layouts/login/login';
import Page404 from './pages/Page404';
import DashboardAppPage from './pages/DashboardAppPage';
import { AuthuProtectedRoute } from './protectedRoute';
import GalleryMain from './layouts/gallery/main';

// ----------------------------------------------------------------------

export default function Router() {
  const routes = useRoutes([
    {
      path: '/',
      children: [
        { element: <Navigate to="login" />, index: true }
      ]
    },
    {
      path: '/admin',
      element: <AuthuProtectedRoute><DashboardLayout /></AuthuProtectedRoute>,
      // element: <MainLanding />,
      children: [
        { element: <Navigate to="/admin/dashboard" />, index: true },
        { path: 'dashboard', element: <AuthuProtectedRoute><DashboardAppPage /></AuthuProtectedRoute> },
        { path: 'booking', element: <AuthuProtectedRoute><BookingPage /></AuthuProtectedRoute> },
        { path: 'studio', element: <AuthuProtectedRoute> <StudioPage /></AuthuProtectedRoute> },
        { path: 'users', element: <AuthuProtectedRoute><UsersPage /></AuthuProtectedRoute> }
      ],
    },
    {
      path: 'login',
      element: <Login />,
    },
    {
      element: <AuthuProtectedRoute> <SimpleLayout /></AuthuProtectedRoute>,
      children: [
        { element: <AuthuProtectedRoute> <Navigate to="/dashboard/admin" /></AuthuProtectedRoute>, index: true },
        { path: '404', element: <Page404 /> },
        // { path: '*', element: <Navigate to="/404" /> },
      ],
    },
    {
      path: '*',
      element: <Navigate to="/admin/dashboard" replace />,
    },
  ]);

  return routes;
}
